import { createContext, useContext, useMemo, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [cartSidebarOpen, setCartSidebarOpen] = useState(false);

  const value = useMemo(
    () => ({
      cartSidebarOpen,
      setCartSidebarOpen,
    }),
    [cartSidebarOpen]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUI() {
  const ctx = useContext(UIContext);
  if (!ctx) throw new Error("useUI must be used inside UIProvider");
  return ctx;
}

export default UIContext;
